@let proofTableau = tree();
<svg
    style="width: {{((treeDimensions$|async)?.width ?? 0) + 10}}px; min-height: {{((treeDimensions$|async)?.height ?? 0) + 10}}px;"
    >
  <g tableau-tree [tree]="proofTableau"
  attr.transform="translate({{((treeDimensions$|async)?.width ?? 0)/2}}, 10)"
   (onSize)="onTreeSize($event)"></g>
</svg>
